<template>
  <!-- 计时卡 -->
  <div class="box-card">
    <div style="text-align: left">
      <!-- 查询 -->
      <el-form :inline="true" size="small" label-position="right" class="query_form" :model="queryForm"
        @submit.native.prevent>
        <el-form-item label="车牌号：">
          <el-input maxlength="8" :value="queryForm.plate_number" placeholder="请输入车牌号"
            @input="(e) => (queryForm.plate_number = validPlatetoUpperCase(e))" @keyup.enter.native="onSubmit"></el-input>
        </el-form-item>
        <el-form-item label="停车场：">
          <el-select popper-class="my-select" clearable v-model="queryForm.parking_id" filterable default-first-option
            placeholder="请选择停车场" @change="onSubmit">
            <el-option v-for="item in parkingList" :key="item.parking_id" :label="item.parking_name"
              :value="item.parking_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在地：">
          <el-input maxlength="30" :value="queryForm.address" placeholder="请输入所在地"
            @input="(e) => (queryForm.address = validSpacing(e))" @keyup.enter.native="onSubmit"></el-input>
        </el-form-item>
        <el-form-item>
          <lbButton icon="chaxun" :fill="true" @click="onSubmit()">查询</lbButton>
        </el-form-item>
      </el-form>
      <le-card title="计时卡">
        <template slot="heard-right">
          <div>
            <lbButton type="info" icon="daoru1" @click="openImportDialog"
              v-if="isShowBtn('96307e16751d4782b726297f') || isShowBtn('a91535da00fd4d4791cad318')">导入</lbButton>
            <lbButton type="warning" icon="daochu" @click="exportFile"
              v-if='isShowBtn("e72e759df9e4460aabd7bcf7") || isShowBtn("46c4632f88c34dcbb18097ec")'>导出</lbButton>
            <lbButton type="err" icon="shanchu1" @click="deleteTimeCard"
              v-if='isShowBtn("d861eb7641fa42cb8315874a") || isShowBtn("96b1dde046b94f39bf9d70a1")'>删除</lbButton>
            <lbButton icon="xinzeng" @click="showAddTimeCard = true"
              v-if='this.getUserInfo.user_name != "admin" && (isShowBtn("712d38f12553419fa30e1718") || isShowBtn("fb2aca9c8d5143dc87ead012"))'>
              新增</lbButton>
          </div>
        </template>
        <div>
          <!-- 表格 -->
            <!-- 使用插件生产表格 -->
         <!-- <avue-crud :data="tableData" :option="option" :page.sync="page" @selection-change="selectionChange"
            @size-change="sizeChange" @current-change="currentChange">
              <template slot-scope="{row}" slot="parking_name">
                <span>{{ row.parking_name ? row.parking_name : '/' }}</span>
            </template>
             <template slot-scope="{row}" slot="car_owner_card_type">
              <span>{{ getWayName("CarOwnerCardType", row.car_owner_card_type) }}</span>
            </template>
             <template slot-scope="{row}" slot="cost_scheme_name">
              <span>{{ row.cost_scheme_name ? row.cost_scheme_name : '/' }}</span>
            </template>
              <template slot-scope="{row}" slot="create_time">
                {{ $moment(row.create_time).format('YYYY-MM-DD HH:mm:ss') }}
            </template>
            <template slot-scope="{row}" slot="menu">
              <lbButton type="succes" icon="chakan" hint="查看" @click="lookTimeCard(row)"></lbButton>
                <lbButton type="warning" icon="bianji" hint="编辑" @click="editTimeCard(row._id)"
                  v-if='isShowBtn("adfaf117b8744e5997dff974") || isShowBtn("0de3009cda2142fc933684a2")'></lbButton>
            </template>
          </avue-crud> -->
          <el-table class="tablestyle" ref="multipleTable" :data="tableData" align="center" header-align="center"
            tooltip-effect="dark" border stripe @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50" align="center" header-align="center"></el-table-column>
            <el-table-column prop="plate_number" label="车牌号"></el-table-column>
            <el-table-column label="停车场">
              <template slot-scope="scope">
                <span>{{ scope.row.parking_name ? scope.row.parking_name : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="卡类型">
              <template slot-scope="scope">
                <span>{{ getWayName("CarOwnerCardType", scope.row.car_owner_card_type) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="计费方案">
              <template slot-scope="scope">
                <span>{{ scope.row.cost_scheme_name ? scope.row.cost_scheme_name : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="创建时间">
              <template slot-scope="scope">
                {{ $moment(scope.row.create_time).format('YYYY-MM-DD HH:mm:ss') }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <lbButton type="succes" icon="chakan" hint="查看" @click="lookTimeCard(scope.row)"></lbButton>
                <lbButton type="warning" icon="bianji" hint="编辑" @click="editTimeCard(scope.row._id)"
                  v-if='isShowBtn("adfaf117b8744e5997dff974") || isShowBtn("0de3009cda2142fc933684a2")'></lbButton>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="queryForm.PageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="queryForm.PageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="TotalCount"></el-pagination>
        </div>
      </le-card>

    </div>
    <!-- 导入对话框 -->
    <lebo-dialog append-to-body title="导入" :isShow="isImportDialog" width="30%" @close="closeImportDialog" footerSlot>
      <el-form :model="importForm" :rules="importFormRules" ref="importFormRef" label-width="120px" class="import_form">
        <el-form-item label="停车场：" prop="parking_id">
          <el-select popper-class="my-select" v-model="importForm.parking_id" placeholder="请选择停车场"
            @change="parkingIdChange">
            <el-option v-for="item in originParkinList" :key="item.parking_id" :label="item.parking_name"
              :value="item.parking_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计费方案：" prop="cost_scheme_id">
          <el-select popper-class="my-select" v-model="importForm.cost_scheme_id" placeholder="请选择计费方案">
            <el-option v-for="item in bilProSelectList" :key="item._id" :label="item.scheme_name" :value="item._id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="附件：" prop="remarks">
          <div class="upload_box">
            <el-upload class="logo-upload" action="''" :http-request="upload" :show-file-list="true"
              :file-list="fileList">
              <lbButton size="small" type="warning">点击上传</lbButton>
            </el-upload>
            <el-link href="/webmanage/xlsx/计时卡模板.xlsx" download="计时卡模板.xlsx" type="primary"
              style="margin-left: 15px;">下载模板</el-link>
          </div>
        </el-form-item>
        <el-form-item label="失败原因：" v-if="errMsg" class="err_box">
          <div>{{ uploadMsg }}</div>
          <div v-for="(item, index) in errMsg" :key="index">{{ index + 1 }}、{{ item }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <lbButton type="goBack" icon="back" class="checkButton2" @click="closeImportDialog" v-preventReClick>返 回</lbButton> -->
        <lbButton type="default" fill icon="confirm" @click="sendImport" v-preventReClick>确 定</lbButton>
      </span>
    </lebo-dialog>
    <!-- 新增计时卡 -->
    <lebo-dialog :isShow="showAddTimeCard" width="70%" title="新增计时卡" :footerSlot="true" @close="showAddTimeCard = false">
      <addTimeCard :id="'new'" @closeDialog="closeTimeCard" v-if="showAddTimeCard"></addTimeCard>
    </lebo-dialog>
    <!-- 编辑计时卡 -->
    <lebo-dialog :isShow="showEditTimeCard" width="70%" title="编辑计时卡" :footerSlot="true" @close="showEditTimeCard = false">
      <addTimeCard :id="dialogTimrCardId" @closeDialog="closeTimeCard" v-if="showEditTimeCard"></addTimeCard>
    </lebo-dialog>
    <!-- 查看计时卡 -->
    <lebo-dialog class="lookDetailCard" :isShow="showDetailTimeCard" width="55%" title="查看计时卡" :footerSlot="true"
      @close="showDetailTimeCard = false" closeOnClickModal>
      <lookDetailCard :id="dialogTimrCardId" :cardType="dialogCardType" v-if="showDetailTimeCard"
        @closeDialog="closeTimeCard"></lookDetailCard>
    </lebo-dialog>
  </div>
</template>

<script>
import request from '@/api/carmanager'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import addTimeCard from './components/addTimeCard/index.vue'
import lookDetailCard from '../components/lookDetailCard/index.vue'
export default {
  components: { addTimeCard, lookDetailCard },
  data () {
    return {
      // 查询表单
      queryForm: {
        parking_id: null,
        plate_number: '',
        car_owner_card_type: 1,
        PageSize: 10,
        PageIndex: 1,
        address: ''
      },
      // 表格数据
      tableData: [],
      seleteTableData: [],
      TotalCount: 0,
      // 展示导入对话框
      isImportDialog: false,
      // 导入表单
      importForm: {
        parking_id: '', // 停车场id
        cost_scheme_id: '', // 计费方案 id car_owner_card_type!=4时为必填
        remarks: '', // 附件地址
        car_owner_card_type: 1 // 卡片类型 0:临停车 1:计时卡2:月租卡 3:储值卡 4:贵宾卡
      },
      importFormRules: {
        parking_id: [
          { required: true, message: '请选择停车场', trigger: 'blur' }
        ],
        cost_scheme_id: [
          { required: true, message: '请选择计费方案', trigger: 'blur' }
        ],
        remarks: [
          { required: true, message: '请选择附件', trigger: 'blur' }
        ]
      },
      // 计费方案下拉列表
      bilProSelectList: [],
      // 文件列表
      fileList: [],
      // 导入卡片失败原因
      errMsg: null,
      uploadMsg: '', // 导入结果
      showAddTimeCard: false, // 新增计时卡弹窗
      showEditTimeCard: false,
      showDetailTimeCard: false,
      dialogTimrCardId: '', // 计时卡id
      dialogCardType: '', // 卡片类型
      // 表格插件配置项
      option: {
        searchMenuSpan: 8,
        header: false,
        delBtn: false, // 行删除按钮
        editBtn: false, // 编辑按钮
        selection: true,
        selectionFixed: false, // 解除选择框冻结
        // searchBtn:false,
        menuAlign: 'left', // 属性对齐方式
        menuHeaderAlign: 'left', // 表头对齐方式
        menu: true,
        menuFixed: false, // 解除操作框冻结
        tip: false,
        column: [
          {
            label: '车牌号',
            prop: 'plate_number'
          }, {
            label: '停车场',
            prop: 'parking_name',
            slot: true
          }, {
            label: '卡类型',
            prop: 'car_owner_card_type',
            slot: true
          }, {
            label: '计费方案',
            prop: 'cost_scheme_name',
            slot: true
          }, {
            label: '创建时间',
            prop: 'create_time',
            slot: true
          }
        ]
      },
      // 分页器
      page: {
        background: false,
        total: 0,
        pageSize: 10,
        currentPage: 1
      }
    }
  },
  created () {
    if (this.queryStatus === 2) {
      this.queryForm = this.deepClone(this.queryObj)
      console.log(this.queryForm)
    }
    this.fnGetTimeCardList()
  },
  computed: {
    ...mapState(['parkingList', 'queryObj', 'queryStatus', 'originParkinList']),
    ...mapState('menuList', ['isRoutW']),
    ...mapGetters(['getWayName', 'getOptions', 'getUserInfo'])
  },
  mounted () {
    window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  beforeRouteLeave (to, from, next) {
    this.setQueryObj(this.queryForm)
    this.setQueryStatus(1)
    next()
  },
  destroyed () {
    window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  methods: {
    ...mapActions(['requestPorkingList']),
    ...mapMutations(['setQueryObj', 'setQueryStatus']),
    beforeunloadFn (e) {
      this.setQueryStatus(1)
    },
    // 获取计时卡列表
    async fnGetTimeCardList () {
      const res = await request.cardInfoList(this.queryForm)
      if (res && res.Code === 200) {
        this.tableData = res.Data.DataList
        this.TotalCount = res.Data.TotalCount
      } else {
        this.tableData = []
        this.TotalCount = 0
      }
      this.page.total = res && res.Code === 200 && res.Data ? res.Data.TotalCount : 0
    },
    onSubmit () {
      this.queryForm.PageIndex = 1
      this.fnGetTimeCardList()
    },
    // 每页条数改变
    handleSizeChange (size) {
      this.queryForm.PageSize = size
      this.fnGetTimeCardList()
    },
    // // 每页条数改变
    // sizeChange (val) {
    //   this.page.currentPage = 1
    //   this.page.pageSize = val
    //   this.queryForm.PageSize = val
    //   this.fnGetTimeCardList()
    // },
    // 页码改变
    handleCurrentChange (page) {
      this.queryForm.PageIndex = page
      this.fnGetTimeCardList()
      this.$refs.multipleTable.bodyWrapper.scrollTop = 0
    },
    // // 页码改变
    // currentChange (val) {
    //   this.queryForm.PageIndex = val
    //   this.page.currentPage = val
    //   this.fnGetTimeCardList()
    // },
    // 表格选中项发生改变
    handleSelectionChange (val) {
      this.seleteTableData = val
    },
    // // 选中的数据
    // selectionChange (list) {
    //   this.seleteTableData = list
    // },
    // 删除选中的计时卡
    deleteTimeCard () {
      if (this.seleteTableData.length > 0) {
        this.$confirm('此操作将永久的删除选中的计时卡, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$msg.success('删除成功!');
          var obj = {}
          var arr = []
          for (var i = 0; i < this.seleteTableData.length; i++) {
            arr.push(this.seleteTableData[i]._id)
            if (arr.length === this.seleteTableData.length) {
              obj._ids = arr
              this.fnDelTimeCard(obj)
            }
          }
        }).catch(() => {
          this.$msg.info('已取消删除')
        })
      } else {
        this.$msg.warning('请选择要删除的计时卡！')
      }
    },
    // 删除计时卡请求
    async fnDelTimeCard (obj) {
      const res = await request.deleteCard(obj)
      if (res && res.Code === 200) {
        this.$msg.success(res.Message)
      }
      this.fnGetTimeCardList()
    },
    // 导出计时卡
    async exportFile () {
      const res = await request.cardInfoList({
        parking_id: this.queryForm.parking_id,
        plate_number: this.queryForm.plate_number,
        car_owner_card_type: 1,
        PageSize: 0,
        PageIndex: 0
      })
      // console.log(res.Data.DataList);
      const resultList = res.Data.DataList
      if (resultList.length <= 0) {
        this.$msg.warning('暂无数据！')
      } else {
        // 设置当前日期
        var name = this.$moment(new Date()).format('YYYY-MM-DD')
        // console.log(name);
        import('@/utils/Export2Excel').then((excel) => {
          const tHeader = [
            '车牌号',
            '停车场',
            '卡类型',
            '计费方案',
            '创建时间'
          ]
          const filterVal = [
            'plate_number',
            'parking_name',
            'car_owner_card_type',
            'cost_scheme_name',
            'create_time'
          ]
          const list = resultList
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader, //  必填   导出数据的表头
            data, //  必填   导出具体数据
            filename: '计时卡卡片信息' + name, //  非必填   导出文件名
            autoWidth: true, //  非必填   单元格是否自动适应宽度
            bookType: 'xlsx' //  非必填   导出文件类型
          })
        })
      }
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        var map = {}
        this.$set(map, j, v[j])
        return this.formatter(map, { property: j })
        // 为formatter专门为了码表渲染的组件
      })
      )
    },
    // 数据格式化
    formatter (row, column) {
      // console.log(row);
      // console.log(column);
      // 日期处理
      if (column.property === 'create_time') {
        return this.$moment(row[column.property]).format('YYYY-MM-DD HH:mm:ss')
      } else if (column.property === 'car_owner_card_type') {
        return row.car_owner_card_type = this.getWayName('CarOwnerCardType', row.car_owner_card_type)
      } else {
        return row[column.property] ? row[column.property] : '/'
      }
    },
    // 展示导入对话框
    openImportDialog () {
      this.requestPorkingList()
      this.isImportDialog = true
      // console.log(this.originParkinList);
    },
    // 停车场选项发生改变时触发
    parkingIdChange (val) {
      this.fnGetBilProSelectList(val)
      this.importForm.cost_scheme_id = ''
    },
    // 停车场绑定计时/计次/时段卡计费方案下拉列
    async fnGetBilProSelectList (id) {
      const res = await request.getBilProSelectList({
        parking_id: id
      })
      if (res && res.Code === 200) {
        this.bilProSelectList = res.Data
      } else {
        this.bilProSelectList = []
      }
    },
    // 上传附件
    async upload (item) {
      this.fileList = []
      var formData = new FormData()
      formData.append('file', item.file)
      // console.log('formData', formData)
      const res = await request.uploadFile(formData)
      if (res.data && res.data.length > 0) {
        this.importForm.remarks = res.data[0].FilePath
        this.fileList = [{
          name: res.data[0].FileName,
          url: res.data[0].FilePath
        }]
      }
    },
    // 导入卡片
    sendImport () {
      this.$refs.importFormRef.validate(async (valid) => {
        if (valid) {
          const res = await request.importCard(this.importForm)
          console.log('importCard------', res)
          if (res && res.Code === 200) {
            if (res.Data) {
              this.errMsg = res.Data
            } else {
              // this.$msg.success(res.Message)
              this.isImportDialog = false
            }
            this.uploadMsg = res.Message
            this.onSubmit()
          } else {
            this.errMsg = [res.Message]
          }
          this.fileList = []
          this.importForm.remarks = ''
        } else {
          return false
        }
      })
    },
    // 关闭导入卡片对话框时触发
    closeImportDialog () {
      this.isImportDialog = false
      this.$refs.importFormRef.resetFields()
      this.fileList = []
      this.errMsg = null
      this.bilProSelectList = []
      console.log(this.importForm)
    },
    // 关闭刷新
    closeTimeCard () {
      this.showAddTimeCard = false
      this.showEditTimeCard = false
      this.showDetailTimeCard = false
      this.fnGetTimeCardList()
    },
    // 编辑计时卡
    editTimeCard (row) {
      this.showEditTimeCard = true
      this.dialogTimrCardId = row
    },
    // 查看计时卡
    lookTimeCard (row) {
      console.log('rowlookl', row)
      this.showDetailTimeCard = true
      this.dialogTimrCardId = row._id
      this.dialogCardType = row.car_owner_card_type
    }
  }
}
</script>

<style scoped lang="less">
.box-card {
  margin-top: 20px;
}

.import_form {
  margin: 0 25px;

  /deep/ .el-select {
    width: 100%;
  }
}

.upload_box {
  position: relative;
  display: flex;
  align-items: flex-start;

  .el-link {
    position: absolute;
    left: 100px;
  }
}

.err_box {
  color: #f56666;
  max-height: 320px;
  overflow-y: auto;

  /deep/ .el-form-item__label {
    color: #f56666;
  }
}

.lookDetailCard {
  min-height: 60%;

  /deep/.el-dialog {
    min-height: 60%;

  }
}</style>
